import { urls } from "../../urls";

const fetchDenyPrenotificationData = async (subscriptionId: string, username: string) => {
    const rapbackUrl = urls.RAPBACK
    const url: string = `${process.env.NODE_ENV === "production" ? rapbackUrl : ""}/subscription/deny/${subscriptionId}?deletion_source=prenotify&username=${username}`;
    try {
        return await fetch(url, {
            method: "POST",
            credentials: "include"
        })
    } catch (err: any) {
        console.error('error querying rapback Deny Prenotification: ', err)
        return {
            message: "error",
            status: 400,
            ok: false
        }
    }
}

export default fetchDenyPrenotificationData